export default __webpack_public_path__ + "static/media/apple.5548ad0c.txt";